export const MINIMUM_INITIAL_PITCH_AMOUNT = 25;
